import {useState} from "react";
import {css} from "@emotion/css";
import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import RaikoSimpleInputOutlined from "../../raikoComponents/raikoCustomInput/RaikoSimpleInputOutlined";
import RaikoToggleOutlined from "../../raikoComponents/raikoCustomInput/raikoToggleOutlined/RaikoToggleOutlined";
import ButtonDivisionSection from "../ButtonDivisionSection/ButtonDivisionSection";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import {SpecialNewsService} from "../../pages/specialNews/SpecialNewsService";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbar} from "notistack";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";

export default function SpecialNewsAddNewItem({handleCloseDialog, handleAddNewItem}) {

    const service = new SpecialNewsService();
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [title, setTitle] = useState("");
    const [url, setUrl] = useState("");
    const [enabled, setEnabled] = useState(false);

    function handleAddItem() {
        if (checkFields()) {
            loading.show()
            service.addNewItem(title, url)
                .then(response => {
                    handleAddNewItem(response)
                    snackbar.showSuccessMessage("خبر ویژه ی جدید با موفقیت افزوده شد.")
                    loading.hide()
                    handleCloseDialog()
                }).catch(reason => {

                snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در ساخت خبر ویژه جدید."))
                loading.hide()
            })
        }
    }

    function checkFields() {
        let state = false
        let message = ""

        if (title.length === 0) {
            message = "لطفا عنوان خبر را به درستی وارد نمایید."
        } else if (url.length === 0) {
            message = "لطفا لینک مقصد را به درستی وارد نمایید."
        } else
            state = true


        snackbar.showWarningMessage(message)
        return state
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem`}>
            <RaikoSimpleInputOutlined labelText={"عنوان خبر"} setValue={setTitle} value={title}/>
            <RaikoSimpleInputOutlined labelText={"لینک مقصد"} setValue={setUrl} value={url}/>
            {/*<RaikoToggleOutlined labelText={"وضعیت انتشار"} setChecked={setEnabled} checked={enabled}/>*/}
            <ButtonDivisionSection>
                <ButtonPrimaryRaiko label={"افزودن"} onClick={handleAddItem}/>
            </ButtonDivisionSection>
        </RaikoGridOneColumn>
    )
}